<!-- =========================================================================================
    File Name: DashboardEcommerce.vue
    Description: Dashboard - Ecommerce
    ----------------------------------------------------------------------------------------
    Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
      Author: Pixinvent
    Author URL: http://www.themeforest.net/user/pixinvent
========================================================================================== -->

<template>
  <div class="vx-row">
    <div class="vx-col w-full lg:w-full mb-base">
      <vx-card title="ข้อมูลผู้กู้" class="mb-5">
        <div class="vx-row">
          <div class="vx-col w-full lg:w-1/2 sm:w-full">
            <div class="vx-row">
              <div class="vx-col w-full " v-bind:class="[!mobileSc ? 'flex' : '']">
                <span class="bold text-left">ชื่อบัญชี</span><vs-spacer />
                <span class="text-right">{{ _contractDetail.contractName }}</span>
              </div>
            </div>
            <div class="vx-row">
              <div class="vx-col w-full " v-bind:class="[!mobileSc ? 'flex' : '']">
                <span class="bold text-left">เลขที่บัญชีเงินกู้</span><vs-spacer />
                <span class="text-right">{{ _contractDetail.contractNo }}</span>
              </div>
            </div>
            <div class="vx-row">
              <div class="vx-col w-full " v-bind:class="[!mobileSc ? 'flex' : '']">
                <span class="bold text-left">ประเภทบัญชีเงินกู้</span><vs-spacer />
                <span class="text-right">{{ _contractDetail.loanTypeName }}</span>
              </div>
            </div>
            <div class="vx-row">
              <div class="vx-col w-full " v-bind:class="[!mobileSc ? 'flex' : '']">
                <span class="bold text-left">สถานะบัญชีเงินกู้</span><vs-spacer />
                <span class="text-right">{{ _contractDetail.contractStatus | contractStatus }}</span>
              </div>
            </div>
            <div class="vx-row">
              <div class="vx-col w-full " v-bind:class="[!mobileSc ? 'flex' : '']">
                <span class="bold text-left">สถานะภาพทางการศึกษา</span><vs-spacer />
                <span class="text-right">{{ _contractDetail.educationStatus | educationStatus}}</span>
              </div>
            </div>
            <div class="vx-row">
              <div class="vx-col w-full " v-bind:class="[!mobileSc ? 'flex' : '']">
                <span class="bold text-left">การผ่อนผัน / ขอระงับเรียกให้ชำระหนี้</span><vs-spacer />
                <span class="text-right">ไม่มี</span>
              </div>
            </div>
          </div>
        </div>
      </vx-card>
      <vx-card title="รายละเอียดบัญชี" class="mb-5">
        <div class="vx-row">
          <div class="vx-col w-full lg:w-1/2 sm:w-full">
            <div class="vx-row">
              <div class="vx-col w-full " v-bind:class="[!mobileSc ? 'flex' : '']">
                <span class="bold text-left">ข้อมูล ณ วันที่</span><vs-spacer />
                <span class="text-right">{{ nowUpdate }}</span>
              </div>
            </div>
            <div class="vx-row">
              <div class="vx-col w-full " v-bind:class="[!mobileSc ? 'flex' : '']">
                <span class="bold text-left">ยอดเงินกู้ทั้งหมด (บาท)</span><vs-spacer />
                <span class="text-right">{{ _contractDetail.loanAmount| numberFormat}}</span>
              </div>
            </div>
            <div class="vx-row">
              <div class="vx-col w-full " v-bind:class="[!mobileSc ? 'flex' : '']">
                <span class="bold text-left">วันที่ครบกำหนดชำระครั้งแรก</span><vs-spacer />
                <span class="text-right">{{ firstPaymentRoundDate }}</span>
              </div>
            </div>
            <div class="vx-row">
              <div class="vx-col w-full " v-bind:class="[!mobileSc ? 'flex' : '']">
                <span class="bold text-left">ยอดเงินต้นคงเหลือ (บาท)</span><vs-spacer />
                <span class="text-right">{{ _contractDetail.principleRemain | numberFormat}}</span>
              </div>
            </div>
            <div class="vx-row">
              <div class="vx-col w-full " v-bind:class="[!mobileSc ? 'flex' : '']">
                <span class="bold text-left">ดอกเบี้ยคงเหลือ (บาท)</span><vs-spacer />
                <span class="text-right">{{ _contractDetail.accruedInterestRemain | numberFormat}}</span>
              </div>
            </div>
            <div class="vx-row">
              <div class="vx-col w-full " v-bind:class="[!mobileSc ? 'flex' : '']">
                <span class="bold text-left">เบี้ยปรับคงเหลือ (บาท)</span><vs-spacer />
                <span class="text-right">{{ _contractDetail.accruedPenaltyRemain | numberFormat}}</span>
              </div>
            </div>
            <div class="vx-row">
              <div class="vx-col w-full " v-bind:class="[!mobileSc ? 'flex' : '']">
                <span class="bold text-left">ค่าธรรมเนียมคงเหลือ (บาท)</span><vs-spacer />
                <span class="text-right">{{ _contractDetail.accruedFeeRemain | numberFormat}}</span>
              </div>
            </div>
          </div>

          <div class="vx-col w-full lg:w-1/2 sm:w-full">
            <div class="vx-row">
              <div class="vx-col w-full " v-bind:class="[!mobileSc ? 'flex' : '']">
                <span class="bold text-left">ดอกเบี้ยรับล่วงหน้าคงเหลือ (บาท)</span><vs-spacer />
                <span class="text-right">{{ _contractDetail.balanceRemain | numberFormat}}</span>
              </div>
            </div>
            <div class="vx-row" v-if="_contractDetail.contractFeeRemain > 0">
              <div class="vx-col w-full " v-bind:class="[!mobileSc ? 'flex' : '']">
                <span class="bold text-left">ค่าธรรมเนียมการทำสัญญาคงเหลือ (บาท)</span><vs-spacer />
                <span class="text-right">{{ _contractDetail.contractFeeRemain | numberFormat}}</span>
              </div>
            </div>
            <div class="vx-row" v-if="_contractDetail.taxAmountRemain > 0">
              <div class="vx-col w-full " v-bind:class="[!mobileSc ? 'flex' : '']">
                <span class="bold text-left">ค่าอากรแสตมป์คงเหลือ (บาท)</span><vs-spacer />
                <span class="text-right">{{ _contractDetail.taxAmountRemain | numberFormat}}</span>
              </div>
            </div>
            <div class="vx-row" v-if="_contractDetail.processingFeeRemain > 0">
              <div class="vx-col w-full " v-bind:class="[!mobileSc ? 'flex' : '']">
                <span class="bold text-left">ค่าดำเนินการคงเหลือ (บาท)</span><vs-spacer />
                <span class="text-right">{{ _contractDetail.processingFeeRemain | numberFormat}}</span>
              </div>
            </div>
            <div class="vx-row" v-if="_contractDetail.courtOrderExpenseRemain > 0">
              <div class="vx-col w-full " v-bind:class="[!mobileSc ? 'flex' : '']">
                <span class="bold text-left">ค่าใช้จ่ายอื่นตามคำสั่งศาลคงเหลือ (บาท)</span><vs-spacer />
                <span class="text-right">{{ _contractDetail.courtOrderExpenseRemain | numberFormat}}</span>
              </div>
            </div>
            <div class="vx-row">
              <div class="vx-col w-full " v-bind:class="[!mobileSc ? 'flex' : '']">
                <span class="bold text-left">ยอดชำระเพื่อปิดบัญชี (บาท)</span><vs-spacer />
                <span class="text-right">{{ _contractDetail.totalCloseAmount | numberFormat}}</span>
              </div>
            </div>
          </div>
        </div>
      </vx-card>
      <vx-card title="ข้อมูลการชำระเงิน" class="mb-5">
        <div class="vx-row">
          <div class="vx-col w-full lg:w-1/2 sm:w-full">
            <div class="vx-row">
              <div class="vx-col w-full " v-bind:class="[!mobileSc ? 'flex' : '']">
                <span class="bold text-left">วันที่ชำระเงินล่าสุด</span><vs-spacer />
                <span class="text-right">{{ lastPaymentDate }}</span>
              </div>
            </div>
            <div class="vx-row">
              <div class="vx-col w-full " v-bind:class="[!mobileSc ? 'flex' : '']">
                <span class="bold text-left">จำนวนเงินที่ชำระล่าสุด (บาท)</span><vs-spacer />
                <span class="text-right">{{ lastPaymentAmount | numberFormat }}</span>
              </div>
            </div>
          </div>
          <div class="vx-col w-full lg:w-1/2 sm:w-full">
            <div class="vx-row">
              <div class="vx-col w-full " v-bind:class="[!mobileSc ? 'flex' : '']">
                <span class="bold text-left">วันที่คิดดอกเบี้ยล่าสุด</span><vs-spacer />
                <span class="text-right">{{ lastUpdate }}</span>
              </div>
            </div>
            <div class="vx-row">
              <div class="vx-col w-full " v-bind:class="[!mobileSc ? 'flex' : '']">
                <span class="bold text-left">วันที่ชำระเงินครั้งถัดไป</span><vs-spacer />
                <span class="text-right">{{ nextPaymentRoundDate }}</span>
              </div>
            </div>
          </div>
        </div>
      </vx-card>

    </div>
  </div>
</template>

<script>
import { createNamespacedHelpers } from 'vuex'
const { mapActions: mapAccountingActions, mapState: mapAccountingState } = createNamespacedHelpers('Accounting')
const moment = require('moment');
import { round, isEmpty } from '@/utils'

export default {
  async created() {
    const vm = this
    if(isEmpty(vm.contract)){
      vm.$router.push("/")
    }else{
      const { getContract, getLastPaymentByContractId, getPaymentRoundDetailByContractId } = vm
      await getContract({ form: {id: vm.contract.id} });
      await getLastPaymentByContractId({ form: {contractId: vm.contract.id }})
      await getPaymentRoundDetailByContractId({form: {contractId: vm.contract.id}});
    }
  },
  computed: {
    ...mapAccountingState(['status', 'contract', 'loan', 'loanDetails', 'restructuringDetail', 'paymentRoundDetails', 'payment']),
    _contractDetail(){
      if(!this.contract) return  {}
      const { loan, contractName, contractNo, contractStatus, educationStatus} = this.contract
      const { loanAmount, loanTypeName, principleRemain, accruedFeeRemain, accruedPenaltyRemain, accruedInterestRemain, balanceRemain, restructuringFeeRemain, restructuringPenaltyRemain, restructuringInterestRemain, restructuringPrincipleRemain, contractFeeRemain, taxAmountRemain, processingFeeRemain, courtOrderExpenseRemain } = loan

      const totalCloseAmount = round(accruedFeeRemain + accruedPenaltyRemain + accruedInterestRemain + principleRemain + restructuringFeeRemain + restructuringPenaltyRemain + restructuringInterestRemain + restructuringPrincipleRemain + contractFeeRemain + taxAmountRemain + processingFeeRemain + courtOrderExpenseRemain - balanceRemain, 2)
      return  {
        ...this.contract,
        contractName,
        contractNo,
        contractStatus,
        educationStatus,
        loanTypeName,
        principleRemain: round(principleRemain + restructuringPrincipleRemain, 2),
        accruedFeeRemain: round(accruedFeeRemain + restructuringFeeRemain, 2),
        accruedPenaltyRemain:  round(accruedPenaltyRemain + restructuringPenaltyRemain,2),
        accruedInterestRemain: round(accruedInterestRemain + restructuringInterestRemain, 2),
        balanceRemain,
        contractFeeRemain,
        taxAmountRemain,
        processingFeeRemain,
        courtOrderExpenseRemain,
        totalCloseAmount,
        loanAmount,
      }
    },
    mobileSc () {
      return this.$store.state.windowWidth < 480;
    },
    loanAmount(){
      const vm = this
      const loanDetailAmount = vm.loanDetails.reduce((sum, res) => {
        let amount = 0
        if(res.transaction) amount =  res.amount
				return sum + amount;
			}, 0);
      const restructuringDetailAmount = ( vm.contract.restructuring ? vm.restructuringDetail.principleRemain : 0 )
      return round(loanDetailAmount + restructuringDetailAmount, 2)
    },
    nowUpdate(){
      return this.$options.filters.toThaiDDMMMYYYYFormat(moment(this.contract.loan.lastUpdate).add(1, 'days').format("YYYY-MM-DD"))
    },
    lastUpdate(){
      return this.$options.filters.toThaiDDMMMYYYYFormat(moment(this.contract.loan.lastUpdate).format("YYYY-MM-DD"))
    },
    firstPaymentRoundDate(){
      try {
        const vm = this
        let paymentRound = vm.paymentRoundDetails.find(res => res.type === 'first')
        return vm.$options.filters.toThaiDDMMMYYYYFormat(moment(paymentRound.paymentRoundDate).format("YYYY-MM-DD"))
      } catch (error) {
        return "-"
      }
    },
    nextPaymentRoundDate(){
      try {
        const vm = this
        let paymentRound = vm.paymentRoundDetails.find(res => res.type === 'last')
        return vm.$options.filters.toThaiDDMMMYYYYFormat(moment(paymentRound.paymentRoundDate).format("YYYY-MM-DD"))
      } catch (error) {
        return "-"
      }
    },
    lastPaymentDate(){
      if(!this.payment) return "-"
      return this.$options.filters.toThaiDDMMMYYYYFormat(moment(this.payment.paymentDate).format("YYYY-MM-DD"))
    },
    lastPaymentAmount(){
      if(!this.payment) return 0.00
      return this.payment.paymentAmount
    },
  },
  methods: {
    ...mapAccountingActions([
      'getContract',
      'getPaymentRoundDetailByContractId',
      'getLastPaymentByContractId'
    ]),
  },
  watch: {
    status: {
      handler(res) {
        if (res.processing !== null) {
          if (res.processing) {
            this.$vs.loading();
          } else {
            this.$vs.loading.close();
          }
        }
        if (res.success !== null) {
          this.$vs.notify({...res.success})
        } else if (res.error !== null) {
          this.$vs.notify({...res.error})
        }
      },
      deep: true
    },
  }
};
</script>

<style scoped>
  span.bold{
    color: #000000;
    font-size: 15px;
    font-weight: 600;
  }
</style>
